export const setTourStoreSettings = (store, hasData) => {
  store.tours = {
    cloneHasToured: !!store?.tours?.cloneHasToured,
    createHasToured: !!store?.tours?.createHasToured,
    editHasToured: !!store?.tours?.editHasToured,
    overviewHasToured: !!store?.tours?.overviewHasToured,
    syncHasToured: !!store?.tours?.syncHasToured,
    hasData: store?.tours?.hasData || hasData,
    hasToured: !!store?.tours?.hasToured,
    isDismissed: !!store?.tours?.isDismissed
  };

  return store;
};
